import sr from './translations/sr'
import en from './translations/en'
import ru from './translations/ru'

export default {
  en,
  sr,
  ru
}
